import React, {useState, useRef} from 'react';
import { useStateContext } from '../context/stateContext';
import {toast} from 'react-hot-toast';
import emailjs from '@emailjs/browser';
import { data } from '../utils/data';



const Contact = () => {
  const formRef=useRef(null);
  const {lightTheme, setLinkHovred} = useStateContext();
  const [name, setName]=useState("");
  const [email, setEmail]=useState("");
  const [message, setMessage]=useState("");


  const handelSubmit=()=>{
    let errorMsg="";
    let emailRe = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (name=="" || name==null) {
      errorMsg="Name Length Should Be Between 0 and 30 !";
    }

    if (name.length > 30) {
      errorMsg="Name Length Should Be Less Than 30 !";
    }

    if (!email.match(emailRe) || email=="") {
      errorMsg="Email Invalid !";
    }

    if (message=="" || message==null) {
      errorMsg="Message Should Not Be Empty";
    }

    if (message.length > 300) {
      errorMsg="Sorry But The Max Length Is 300";
    }

    if(errorMsg==""){
      toast.loading("Sending Your Email")
      emailjs.sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_PUB_KEY
      )
      .then((result) => {
        toast.dismiss();
        toast.success("Your Email Sent Successfully");
        setEmail("");
        setName("");
        setMessage("");
      }, (error) => {
        toast.dismiss();
        toast.error("An error occurred while sending your email");
      }); 
    }else{
      toast.error(errorMsg);
    }
  }

  return (
    <section className={`contact-section ${lightTheme?"light":"dark"}`} id="contact">
      <div className="container">
        <h2 className='main-heading' style={{color:`${lightTheme?'#393E46':'#FCFFE7'}`}}>
          Conta<span>c</span>t Me
        </h2>
        <div className="contact-details">
          <div className="contact-form">
            <form ref={formRef}>
              <input name="name" className={`${lightTheme?"light":"dark"}`} type="text" value={name} placeholder="Your Name" onChange={(e)=>{setName(e.target.value)}}/>
              <input name="email" className={`${lightTheme?"light":"dark"}`} type="text" value={email} placeholder="Your Email" onChange={(e)=>{setEmail(e.target.value)}}/>
              <textarea
                className={`${lightTheme?"light":"dark"}`}
                placeholder="Say Something"
                onChange={(e)=>{setMessage(e.target.value)}}
                value={message}
                name="message"
              ></textarea>
              <button
                type='button'
                onClick={handelSubmit}
                onMouseLeave={()=>setLinkHovred(false)}
                onMouseEnter={()=>setLinkHovred(true)}
              >
                Send
              </button>
            </form>
          </div>
          <div className="contact-info">
            <p>Thank you for visiting my portfolio. If you have any questions or would like to discuss a potential project, please don't hesitate to contact me using this form or through the provided phone number or LinkedIn profile. I'll get back to you as soon as possible.</p>
            <div>
              <i className="fa fa-phone"></i>
              <p>{data.phone}</p>
            </div>
            <div>
              <i className="fab fa-linkedin"></i>
              <p><a
                  target='_blank'
                  href={data.linkedIn}
                  onMouseLeave={()=>setLinkHovred(false)}
                  onMouseEnter={()=>setLinkHovred(true)}
              >
                {data.linkedIn.slice(12)}
              </a></p>
            </div>
            <div>
              <i className="fab fa-github"></i>
              <p><a
                  target='_blank'
                  href={data.github}
                  onMouseLeave={()=>setLinkHovred(false)}
                  onMouseEnter={()=>setLinkHovred(true)}
              >
                {data.github.slice(12)}
              </a></p>
            </div>
            <div>
              <i className="fas fa-map-marker-alt fa-fw"></i>
              <p>{data.location}</p>
            </div>
          </div>
        </div>
    </div>
    </section>
  )
}

export default Contact
